import { useState } from 'react';

const AdminPinDigitInput = ({ label, value, onChange, autoComplete = "current-password", required = true }) => {
  const [visible, setVisible] = useState(false);
  return (
    <div className="form-group">
      <label>{label}</label>
      <div style={{ position: "relative" }}>
        <input
          type={visible ? "text" : "password"}
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={6}
          autoComplete={autoComplete}
          value={value}
          onChange={(e) => onChange(e.target.value.replace(/\D/g, "").slice(0, 6))}
          required={required}
          style={{ paddingRight: "2.75rem", width: "100%" }}
        />
        <button
          type="button"
          className="btn btn-ghost btn-sm"
          style={{ position: "absolute", right: 2, top: "50%", transform: "translateY(-50%)", minWidth: 36, padding: "0.35rem" }}
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? "Hide PIN" : "Show PIN"}
          title={visible ? "Hide PIN" : "Show PIN while typing"}
        >
          <i className={`fas ${visible ? "fa-eye-slash" : "fa-eye"}`}></i>
        </button>
      </div>
    </div>
  );
};

export default AdminPinDigitInput;
